export const isEmptyObject = (obj: any) => {
  for (var x in obj) {
    return false;
  }
  return true;
};

export const isPropertyTrue = (property: string) => property.toLocaleLowerCase() === 'true';
